import Vector from "victor";
import { PDFDocumentProxy } from "pdfjs-dist/types/src/display/api";
import * as pdfjs from "pdfjs-dist/legacy/build/pdf.js";

const PDFJS_VERSION = "2.11.338";
pdfjs.GlobalWorkerOptions.workerSrc = `/js/pdf.worker.min.js?${PDFJS_VERSION}`;

export interface PDFInfo {
  url: string;
  render: (ctx: CanvasRenderingContext2D, scale: number) => Promise<void>;
  size: Vector;
  numPages: number;
}

export class PDFController {
  private registry: Record<string, Promise<PDFDocumentProxy>> = {};

  async load(url: string, pageNum: number): Promise<PDFInfo> {
    if (!this.registry[url]) {
      this.registry[url] = pdfjs.getDocument(url).promise;
    }
    const doc = await this.registry[url];
    const page = await doc.getPage(pageNum);
    const viewport = page.getViewport({ scale: 1 });

    return {
      url,
      render: (ctx, scale) =>
        page.render({
          canvasContext: ctx,
          viewport: page.getViewport({ scale }),
        }).promise,
      numPages: doc.numPages,
      size: new Vector(viewport.width, viewport.height),
    };
  }
}
